<template>
  <ul class="product-categories">
    <li v-if="object.main_varietal_object && object.main_varietal_object.name">
      <span v-if="textOnly">{{ object.main_varietal_object.name }}</span>
      <nuxt-link
        v-else
        :to="`${object.main_varietal_object.link}/`"
        @click="clearProduct"
        >{{ object.main_varietal_object.name }}</nuxt-link
      >
    </li>
    <li v-if="object.vintage">
      <span v-if="textOnly">{{ object.vintage }}</span>
      <nuxt-link
        v-else
        :to="`/store/vintage/${object.vintage}/`"
        @click="clearProduct"
        >{{ object.vintage }}</nuxt-link
      >
    </li>
    <li v-if="regionLevel1Object && regionLevel1Object.name">
      <span v-if="textOnly">{{ regionLevel1Object.name }}</span>
      <nuxt-link
        v-else
        :to="`${regionLevel1Object.link}/`"
        @click="clearProduct"
        >{{ regionLevel1Object.name }}</nuxt-link
      >
    </li>
    <li v-if="regionLevel2Object && regionLevel2Object.name">
      <span v-if="textOnly">{{ regionLevel2Object.name }}</span>
      <nuxt-link
        v-else
        :to="`${regionLevel2Object.link}/`"
        @click="clearProduct"
      >
        {{ regionLevel2Object.name }}
      </nuxt-link>
    </li>
  </ul>
</template>

<script>
import {
  getRegionLevel1Object,
  getRegionLevel2Object,
} from '#common/utils/regions'
export default {
  name: 'ProductInterlink',
  props: {
    object: {
      type: Object,
      required: true,
    },
    textOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    regionLevel1Object() {
      return getRegionLevel1Object(this.object)
    },
    regionLevel2Object() {
      return getRegionLevel2Object(this.object)
    },
  },
  created() {
    this.productResults = useProductResults()
  },
  methods: {
    clearProduct() {
      this.productResults.setProductIDInView(undefined)
    },
  },
}
</script>

<style></style>
